import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  HostListener,
} from "@angular/core";
import { MatTabGroup } from "@angular/material";
import { MenuService } from "src/app/services/menu.service";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PracticeRegionFilter } from "src/app/model/practice-region-filter";
import { PhysicianFilter } from "src/app/model/physician-Filter";
import { CacheFilterService } from "src/app/services/cache/cache-filter.service";
import { StudyReportTemplateEdit } from "../../../model/study-report-template-edit";
import { StudyReportService } from "../../../services/study-report/study-report.service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { EnvironmentPresetService } from "../../../services/environment-preset/environment-preset.service";
import { EnvironmentPreset } from "../../../model/environment-preset";
import { TxtControlEditorComponent } from "../../controls/txt-control-editor/txt-control-editor.component";
import { AuthService } from "src/app/services/auth.service";
declare var tinymce: any;

@Component({
  selector: "app-study-report-template-edit",
  templateUrl: "./study-report-template-edit.component.html",
})
export class StudyReportTemplateEditComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild("txtControlEditor", { static: false })
  txtControlEditor?: TxtControlEditorComponent;

  physicianFilters: PhysicianFilter[] = [];
  practiceRegionFilters: PracticeRegionFilter[] = [];
  @ViewChild("tabGroup", { static: false }) tabGroup: MatTabGroup;
  loadingAction: boolean;
  loading: boolean;
  form: FormGroup;
  editor;
  loadEditor: boolean;
  environmentPreset: EnvironmentPreset;
  txControlEnabled: boolean;
  editorId: number;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "25rem",
    minHeight: "5rem",
    translate: "no",
  };

  constructor(
    private menuService: MenuService,
    private authService: AuthService,
    private notificationToastService: NotificationToastService,
    private studyReportService: StudyReportService,
    private router: Router,
    private cacheFilterService: CacheFilterService,
    private formBuilder: FormBuilder,
    private environmentPresetService: EnvironmentPresetService,
    private route: ActivatedRoute,
  ) {
    this.txControlEnabled = this.authService.txControlEnabled();

    this.environmentPreset = this.environmentPresetService.getPreset();
    this.editorConfig.defaultFontName = this.environmentPreset.fontName;

    this.loadEditor = false;
    this.menuService.setMenuTitle("Plantilla", "Edición");
    this.form = this.formBuilder.group({
      Id: [""],
      Name: ["", Validators.required],
      Text: ["", Validators.required],
      PracticeRegions: [""],
      Physicians: [""],
    });
  }

  get f() {
    return this.form.controls;
  }

  cancel(): void {
    if (this.editorId > 1) {
      this.router.navigate([
        "study-report-template-txcontrol-search",
        this.editorId,
      ]);
    } else {
      this.router.navigate(["study-report-template-search", this.editorId]);
    }
  }

  ngAfterViewInit() {
    if (this.txControlEnabled) {
      this.txControlEnabled = this.editorId > 1; // 1 tiny 2 txtcontrol
    }

    if (this.environmentPreset.tinyEditor && !this.txControlEnabled) {
      tinymce.init({
        selector: "#tiny",
        plugins: [
          "link paste table autoresize charmap searchreplace lists advlist textcolor colorpicker code",
        ],
        menubar: "edit insert view format table tools",
        toolbar:
          "undo redo | formatselect | " +
          "bold italic backcolor | alignleft aligncenter " +
          "alignright alignjustify | bullist numlist outdent indent | " +
          "removeformat | fontselect | help",
        browser_spellcheck: true,
        language: "es",
        contextmenu: false,
        table_default_attributes: {},
        table_default_styles: {},
        table_responsive_width: false,
        forced_root_block: "div",
        setup: (editor) => {
          this.editor = editor;
          editor.on("Change", () => {
            const content = editor.getContent();
            this.changeText(content);
          });
        },
      });
    }
  }

  changeText(content: string) {
    this.form.patchValue({ Text: content });
  }

  ngOnDestroy() {
    if (this.environmentPreset.tinyEditor && !this.txControlEnabled) {
      tinymce.remove(this.editor);
    }
  }

  async save() {
    try {
         this.loadingAction = true;

      if (this.txControlEnabled) {
        const document = await this.txtControlEditor.getDocument("", "");

        console.log(document);

        this.form.patchValue({ Text: document.internalUnicodeFormat });
      }

      if (this.form.valid) {

        const studyReportTemplateEdit = new StudyReportTemplateEdit();
        studyReportTemplateEdit.Id = this.form.controls.Id.value;
        studyReportTemplateEdit.Name = this.form.controls.Name.value;
        studyReportTemplateEdit.Text = this.form.controls.Text.value;
        studyReportTemplateEdit.EditorId = this.editorId;

        studyReportTemplateEdit.PracticeRegionIds = [];
        studyReportTemplateEdit.PhysicianIds = [];

        if (this.form.controls.PracticeRegions.value) {
          this.form.controls.PracticeRegions.value.forEach((practiceRegion) => {
            studyReportTemplateEdit.PracticeRegionIds.push(practiceRegion.Id);
          });
        }

        if (this.form.controls.Physicians.value) {
          this.form.controls.Physicians.value.forEach((physician) => {
            studyReportTemplateEdit.PhysicianIds.push(physician.Id);
          });
        }

        await this.studyReportService.studyReportTemplateEditUpdate(
          studyReportTemplateEdit,
        );

        if (this.editorId > 1) {
          this.router.navigate([
            "study-report-template-txcontrol-search",
            this.editorId,
          ]);
        } else {
          this.router.navigate(["study-report-template-search", this.editorId]);
        }
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Plantillas",
      );
    } finally {
      this.loadingAction = false;
    }
  }

  get text() {
    return this.form.get("Text").value;
  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      try {
        this.loading = true;
        const id = params["Id"];
        this.editorId = params["editorId"];

        if (this.txControlEnabled) {
          this.txControlEnabled = this.editorId > 1; // 1 tiny 2 txtcontrol
        }

        this.physicianFilters =
          await this.cacheFilterService.getPhysicianFilters();
        this.practiceRegionFilters =
          await this.cacheFilterService.getPracticeRegionFilters();

        if (id) {
          const studyReportTemplateEdit =
            await this.studyReportService.getStudyReportTemplateEdit(id);
          const physicianExists: PhysicianFilter[] = [];
          const practiceRegionExists: PracticeRegionFilter[] = [];

          this.physicianFilters.forEach((physician) => {
            if (
              studyReportTemplateEdit.PhysicianIds.findIndex(
                (i) => i === physician.Id,
              ) > -1
            ) {
              physicianExists.push(physician);
            }
          });

          this.practiceRegionFilters.forEach((practiceRegion) => {
            if (
              studyReportTemplateEdit.PracticeRegionIds.findIndex(
                (i) => i === practiceRegion.Id,
              ) > -1
            ) {
              practiceRegionExists.push(practiceRegion);
            }
          });

          this.form.patchValue({
            Name: studyReportTemplateEdit.Name,
            Text: studyReportTemplateEdit.Text,
            Id: studyReportTemplateEdit.Id,
            PracticeRegions: practiceRegionExists,
            Physicians: physicianExists,
          });

          if (this.editor && studyReportTemplateEdit.Text) {
            this.editor.setContent(studyReportTemplateEdit.Text);
          }
        }
      } catch (err) {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Plantillas",
        );
      } finally {
        this.loading = false;
      }
    });
  }
}
